import React, { useState } from 'react';

const PLATFORMS = ['Twitter/X', 'LinkedIn', 'Facebook', 'Instagram'];
const PLATFORM_COLORS = { 'Twitter/X':'#1DA1F2', LinkedIn:'#0A66C2', Facebook:'#1877F2', Instagram:'#E1306C' };

const INITIAL_POSTS = [
  { id:1, platform:'LinkedIn',   content:'🌍 Excited to announce TransferExpo is now live in West Africa! Scouts across Lagos, Accra and Nairobi can now connect with top clubs worldwide. #Football #Scouting', status:'Published', date:'Apr 3, 2026 09:00', likes:142, comments:28, shares:34, reach:4200 },
  { id:2, platform:'Twitter/X',  content:'New player evaluations just dropped 🔥 Premium scouts are earning up to $385/month. Join the network → transferexpo.com/scouts', status:'Published', date:'Apr 2, 2026 14:00', likes:89, comments:12, shares:21, reach:2800 },
  { id:3, platform:'Facebook',   content:'Colorado Rapids just activated on TransferExpo — posting their first player requests this week. Club teams, join the platform and find your next signing.', status:'Published', date:'Apr 1, 2026 10:00', likes:67, comments:9, shares:15, reach:1900 },
  { id:4, platform:'LinkedIn',   content:'How does TransferExpo work? 1. Club posts a player request 2. Scout submits an evaluation 3. Club reviews and contacts player 4. Scout gets paid. Simple. Scalable. Global.', status:'Scheduled', date:'Apr 7, 2026 09:00', likes:0, comments:0, shares:0, reach:0 },
  { id:5, platform:'Twitter/X',  content:'', status:'Draft', date:'—', likes:0, comments:0, shares:0, reach:0 },
];

const statusBadge = s => ({ Published:'badge badge-green', Scheduled:'badge badge-blue', Draft:'badge badge-gray' })[s] || 'badge badge-gray';

export default function SocialMedia({ toast }) {
  const [posts, setPosts]       = useState(INITIAL_POSTS);
  const [tab, setTab]           = useState('posts');
  const [composing, setComposing] = useState(false);
  const [draft, setDraft]       = useState({ platform:'LinkedIn', content:'', scheduleLater:false, scheduleDate:'' });
  const [charCount, setCharCount] = useState(0);

  const limits = { 'Twitter/X':280, LinkedIn:3000, Facebook:63206, Instagram:2200 };
  const limit = limits[draft.platform] || 280;

  const publish = () => {
    if (!draft.content.trim()) { toast?.('Write some content first', 'warning'); return; }
    const p = { id:Date.now(), platform:draft.platform, content:draft.content, status:draft.scheduleLater?'Scheduled':'Published', date:draft.scheduleLater?draft.scheduleDate:new Date().toLocaleString('en-GB',{day:'numeric',month:'short',year:'numeric',hour:'2-digit',minute:'2-digit'}), likes:0, comments:0, shares:0, reach:0 };
    setPosts(prev=>[p,...prev]);
    setDraft({ platform:'LinkedIn', content:'', scheduleLater:false, scheduleDate:'' });
    setComposing(false); setCharCount(0);
    toast?.(draft.scheduleLater ? 'Post scheduled!' : 'Post published!');
  };

  const totalReach = posts.filter(p=>p.status==='Published').reduce((s,p)=>s+p.reach,0);
  const totalLikes = posts.filter(p=>p.status==='Published').reduce((s,p)=>s+p.likes,0);

  return (
    <div>
      <div className="stats-grid">
        <div className="stat-card"><div className="stat-label">Total posts</div><div className="stat-value">{posts.filter(p=>p.status==='Published').length}</div><div className="stat-sub">Published</div></div>
        <div className="stat-card"><div className="stat-label">Total reach</div><div className="stat-value">{totalReach.toLocaleString()}</div><div className="stat-sub stat-up">All platforms</div></div>
        <div className="stat-card"><div className="stat-label">Likes</div><div className="stat-value">{totalLikes.toLocaleString()}</div><div className="stat-sub stat-up">Engagement</div></div>
        <div className="stat-card"><div className="stat-label">Scheduled</div><div className="stat-value">{posts.filter(p=>p.status==='Scheduled').length}</div><div className="stat-sub">Upcoming</div></div>
      </div>

      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:16 }}>
        <div className="filter-pills" style={{ marginBottom:0 }}>
          {['posts','calendar'].map(t=><button key={t} className={`pill ${tab===t?'active':''}`} onClick={()=>setTab(t)} style={{ textTransform:'capitalize' }}>{t}</button>)}
        </div>
        <button className="btn btn-primary" onClick={()=>setComposing(true)}>+ New post</button>
      </div>

      {composing && (
        <div className="card" style={{ marginBottom:16 }}>
          <div className="card-header"><span className="card-title">Compose post</span><button className="btn btn-ghost" style={{ fontSize:12 }} onClick={()=>setComposing(false)}>✕</button></div>
          <div style={{ display:'flex', flexDirection:'column', gap:14 }}>
            <div style={{ display:'flex', gap:8, flexWrap:'wrap' }}>
              {PLATFORMS.map(p=>(
                <button key={p} onClick={()=>setDraft(d=>({...d,platform:p}))}
                  style={{ padding:'6px 14px', borderRadius:99, fontSize:12, fontWeight:600, cursor:'pointer', border:`2px solid ${draft.platform===p?PLATFORM_COLORS[p]:'var(--border)'}`, background:draft.platform===p?`${PLATFORM_COLORS[p]}22`:'transparent', color:draft.platform===p?PLATFORM_COLORS[p]:'var(--text-muted)' }}>
                  {p}
                </button>
              ))}
            </div>
            <div>
              <textarea className="search-input" rows={6} placeholder={`Write your ${draft.platform} post...`} value={draft.content}
                onChange={e=>{ setDraft(d=>({...d,content:e.target.value})); setCharCount(e.target.value.length); }}
                style={{ resize:'vertical', fontFamily:'var(--font-body)', lineHeight:1.6 }} />
              <div style={{ display:'flex', justifyContent:'flex-end', marginTop:4 }}>
                <span style={{ fontSize:11, color: charCount > limit ? '#ff4d4d' : 'var(--text-dim)' }}>{charCount}/{limit}</span>
              </div>
            </div>
            <div style={{ display:'flex', gap:16, alignItems:'center' }}>
              <label style={{ display:'flex', alignItems:'center', gap:8, cursor:'pointer', fontSize:13, color:'var(--text-muted)' }}>
                <input type="checkbox" checked={draft.scheduleLater} onChange={e=>setDraft(d=>({...d,scheduleLater:e.target.checked}))} />
                Schedule for later
              </label>
              {draft.scheduleLater && <input type="datetime-local" className="search-input" style={{ maxWidth:220 }} value={draft.scheduleDate} onChange={e=>setDraft(d=>({...d,scheduleDate:e.target.value}))} />}
            </div>
            <div style={{ display:'flex', gap:8 }}>
              <button className="btn btn-primary" onClick={publish} disabled={charCount > limit}>{draft.scheduleLater?'Schedule':'Publish now'}</button>
              <button className="btn btn-ghost" onClick={()=>{ setPosts(prev=>[{id:Date.now(),platform:draft.platform,content:draft.content,status:'Draft',date:'—',likes:0,comments:0,shares:0,reach:0},...prev]); setComposing(false); toast?.('Saved as draft'); }}>Save draft</button>
            </div>
          </div>
        </div>
      )}

      {tab==='posts' && (
        <div style={{ display:'flex', flexDirection:'column', gap:12 }}>
          {posts.map(p=>(
            <div key={p.id} className="card">
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:12 }}>
                <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                  <span style={{ padding:'4px 12px', borderRadius:99, fontSize:12, fontWeight:700, background:`${PLATFORM_COLORS[p.platform]}22`, color:PLATFORM_COLORS[p.platform] }}>{p.platform}</span>
                  <span className={statusBadge(p.status)}>{p.status}</span>
                  <span style={{ fontSize:12, color:'var(--text-dim)' }}>{p.date}</span>
                </div>
                <button className="btn btn-ghost" style={{ fontSize:11, padding:'4px 10px' }} onClick={()=>setPosts(prev=>prev.filter(x=>x.id!==p.id))}>Delete</button>
              </div>
              <div style={{ fontSize:14, color:'var(--text-primary)', lineHeight:1.7, marginBottom:12 }}>{p.content || <span style={{ color:'var(--text-dim)',fontStyle:'italic' }}>No content (draft)</span>}</div>
              {p.status==='Published' && (
                <div style={{ display:'flex', gap:24, paddingTop:12, borderTop:'1px solid var(--border)' }}>
                  {[['👍 Likes',p.likes,'#A7F432'],['💬 Comments',p.comments,'#4fc3f7'],['🔁 Shares',p.shares,'#f5a623'],['👁 Reach',p.reach.toLocaleString(),'#8a9a97']].map(([label,val,color])=>(
                    <div key={label}>
                      <div style={{ fontSize:16, fontWeight:700, color }}>{val}</div>
                      <div style={{ fontSize:11, color:'var(--text-dim)' }}>{label}</div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {tab==='calendar' && (
        <div className="card">
          <div className="card-header"><span className="card-title">Publishing calendar — April 2026</span></div>
          <div style={{ display:'grid', gridTemplateColumns:'repeat(7,1fr)', gap:4 }}>
            {['Mon','Tue','Wed','Thu','Fri','Sat','Sun'].map(d=><div key={d} style={{ textAlign:'center', fontSize:11, color:'var(--text-dim)', padding:'8px 0', fontFamily:'var(--font-ui)' }}>{d}</div>)}
            {Array.from({length:30},(_,i)=>{
              const day = i+1;
              const dayPosts = posts.filter(p=>p.date.includes(`Apr ${day},`)||p.date.includes(`Apr ${day} `));
              return (
                <div key={day} style={{ minHeight:60, padding:6, border:'1px solid var(--border)', borderRadius:6, background:day===4?'rgba(167,244,50,0.05)':'transparent' }}>
                  <div style={{ fontSize:11, color:day===4?'var(--accent)':'var(--text-dim)', fontWeight:day===4?700:400, marginBottom:4 }}>{day}</div>
                  {dayPosts.map(p=>(
                    <div key={p.id} style={{ fontSize:9, padding:'2px 4px', borderRadius:3, background:`${PLATFORM_COLORS[p.platform]}33`, color:PLATFORM_COLORS[p.platform], marginBottom:2, overflow:'hidden', whiteSpace:'nowrap', textOverflow:'ellipsis' }}>
                      {p.platform.split('/')[0]}
                    </div>
                  ))}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
